/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestMetricTargetBrandEntry } from '../../models/harvest-metric-target-brand-entry';

export interface ListBrandsTargets$Params {
  customerId?: number;
}

export function listBrandsTargets(http: HttpClient, rootUrl: string, params?: ListBrandsTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestMetricTargetBrandEntry>>> {
  const rb = new RequestBuilder(rootUrl, listBrandsTargets.PATH, 'get');
  if (params) {
    rb.query('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HarvestMetricTargetBrandEntry>>;
    })
  );
}

listBrandsTargets.PATH = '/api/metric-target/list';
